import styled from 'styled-components';
import { IHeaderStyled, ITextGift } from '@/components/Header/type';

export const HeaderStyled = styled.header<IHeaderStyled>`
  padding: 17px 152px 26px;
  display: flex;
  background-color: #fff;

  @media screen and (max-width: 480px) {
    /* background-color: ${({ success }) => (success ? '#f4f4f4' : '#fff')}; */
    padding: 10px 16px;
    box-shadow: inset 0px 10px 10px -10px rgba(200, 200, 200, 0.5);
  }

  .image-box {
    position: relative;
    width: 100%;
    max-width: 85px;
    min-height: 48px;

    @media screen and (max-width: 480px) {
      max-height: 32px;
      max-width: 32px;
      flex: auto;
    }
  }
`;

export const TextBox = styled.div`
  margin-left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 480px) {
    /* min-width: 200px; */
    width: 200px;
    height: 50px;
    display: flex;
    /* align-items: center; */
    justify-content: flex-start;
    margin-left: 16px;
  }

  h1 {
    font-size: 24px;
    line-height: 1.2;
    font-weight: bold;

    color: #333;
    font-family: VodafoneLt;
    @media screen and (max-width: 480px) {
      font-size: 18px;
      /* margin-bottom: 16px; */
      line-height: 1.25;
      margin-left: 0px;
    }
  }
`;

export const BackClick = styled.div`
  margin-left: auto;
  display: none;
  cursor: pointer;
  color: #ffffff;
  img {
    width: 20px;
    height: 20px;
  }

  @media screen and (max-width: 480px) {
    display: flex;
    align-items: center;
  }
`;

export const ChosenName = styled.div`
  font-size: 18px;
  line-height: 1.33;
  text-align: right;

  color: #666666;
  flex: 1;
  display: flex-end;
  flex-direction: column;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;
export const TextGift = styled.div<ITextGift>`
  font-size: 18px;
  line-height: 1.33;
  color: #666666;
  @media screen and (max-width: 480px) {
    font-size: 16px;
    line-height: 1.25;
    display: ${({ hide }) => (hide ? 'none' : 'block')};
  }
`;
